'use strict';

/**
 * @classname SpSearch
 * @classdesc SP検索
 */
export default class SpSearch {
	/**
	 * @constructor
	 * @param {jQuery} $e - .anchor--search
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._$searchWrap = $('.block--search-sp-wrap');
		$e.on('click', () => this.SpSearchOpen());
		$('.anchor--search-close').on('click', () => this.SpSearchClose());
	};


	/**
	 * 検索エリアを開く
	 *
	 * @memberof SpSearch
	 * @return undefined
	 */
	SpSearchOpen() {
		console.log(`${this.constructor.name}.SpSearchOpen`);
		this._$searchWrap.removeClass('up').addClass('down');
	};


	/**
	 * 検索エリアを閉じる
	 *
	 * @memberof SpSearch
	 * @return undefined
	 */
	SpSearchClose() {
		console.log(`${this.constructor.name}.SpSearchClose`);
		this._$searchWrap.removeClass('down').addClass('up');
	};
};
